import settings from 'config/settings';
import { Api } from './Api';
import { User } from './User'


const getHeaders = () => {
  const jwt = User.getToken()
  const headerAuth = `${jwt.tokenType} ${jwt.accessToken}`
  return {
    'Content-Type': 'application/json',
    Authorization: headerAuth,
  }
}


export class Cloud {
  static async uploadFile(
    file: any,
    progressCallback?: (progressEvent: ProgressEvent) => void
  ): Promise<{ location: string }> {
    // if (!config.accessKeyId) {
      // const res = await Api.get('/config/params/s3')
      // config.bucketName = res['s3.bucketName']
      // config.region = res['s3.region']
      // config.accessKeyId = res['s3.accessKeyID']
      // config.secretAccessKey = res['s3.secretKey']
     try {
      let res:any = await fetch(`${settings.mainApi}/mediaContent/presigned?objectKey=${encodeURIComponent(file?.path)}`,{
        method : "GET",
        headers : getHeaders()
      });

      res = await res?.json();
      const location = res?.location;

      if(res?.url && res?.location){
       try {
        const formData = new FormData();

        if(file && file?.path) {
          formData.append("body",file ,file?.path)
        }

        const jwt = User.getToken()
        const headerAuth = `${jwt.tokenType} ${jwt.accessToken}`

        res = await fetch(res?.url,{
          method : "POST",
          headers : {
          Authorization: headerAuth,
          },
          body: formData
        });

        res = await res.json();

        return 
       } catch (error) {

       }
      }

      return {location };
      
     } catch (error) {
      
     }

  }
}